<template>
  <div
    class="badge"
    :class="[backgroundColor, spacing]"
  >
    <v-btn
      v-if="tooltip"
      v-tooltip="tooltip"
      class="pa-0"
      text
      min-width="8"
      min-height="8"
      small
    >
      <span
        class="badge__content"
        :class="color"
      >{{ getData }}</span>
    </v-btn>

    <span
      v-else
      class="badge__content"
      :class="color"
    >{{ getData }}</span>
  </div>
</template>

<script>

export default {
  name: 'Badge',
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'counter',
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    preset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: '',
    };
  },
  computed: {
    color() {
      if (this.preset) {
        return 'preset-color';
      }

      return !this.$vuetify.theme.dark ? 'dark-theme-color' : '';
    },
    backgroundColor() {
      return this.preset ? 'preset-background-color' : '';
    },
    spacing() {
      return this.isInfoType ? 'spacing' : '';
    },
    isCounterType() {
      return Boolean(this.type === 'counter');
    },
    isInfoType() {
      return Boolean(this.type === 'info');
    },
    getData() {
      return this.isCounterType ? `+${this.data}` : this.data;
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      this.data = newValue;
    },
  },
  mounted() {
    this.data = this.value;
  },
};
</script>

<style scoped lang="scss">
  .badge {
    display: inline-flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: auto;
    min-width: 16px;
    height: 16px;
    border-radius: 16px;
    background-color: var(--ds-color-icon-2);
    margin-left: var(--ds-spacing-stack-nano);

    &__content {
      font-weight: var(--ds-font-weight-bold);
      padding: 0 var(--ds-border-radius-sm);
      line-height: 16px;
      font-size: 10px;
      color: var(--ds-color-text-neutral);
    }
  }

  .preset-color {
    color: var(--ds-color-text-2);
  }

  .preset-background-color {
    background-color: var(--ds-color-overlay);
  }

  .dark-theme-color {
    color: var(--ds-color-white-text);
  }

  .spacing {
    margin: 0 var(--ds-spacing-stack-xs);
  }

  .v-btn::before {
    background-color: transparent;
  }

</style>
